'use client';

import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { Box, HStack } from '@terra/ui-styled-system';
import { MetaDefault } from '../../../../../components/typography';
import type { DataQueryColumnLabels } from './data-query-columns.utils';
import type { DataQueryTableColumns } from './data-query-columns.utils';

export function useDataQueryColumnLabels(): DataQueryColumnLabels {
  const t = useTranslations('designSystem.chat.dataQuery');

  return {
    count: t('columnCount'),
    value: t('columnValue'),
    week: t('columnWeek'),
    month: t('columnMonth'),
    date: t('columnDate'),
    method: t('columnMethod'),
    endpoint: t('columnEndpoint'),
    finding: t('columnFinding'),
    signal: t('columnSignal'),
    execution: t('columnExecution'),
    request: t('columnRequest'),
    status: t('columnStatus'),
    stage: t('columnStage'),
    severity: t('columnSeverity'),
    category: t('columnCategory'),
  };
}

export function DataQueryPanel({ children }: { children: ReactNode }) {
  return (
    <Box
      width="100%"
      borderWidth="1px"
      borderColor="border.subtle"
      borderRadius="md"
      bg="bg.canvas"
      px={3}
      py={2.5}
    >
      {children}
    </Box>
  );
}

export function DataQueryColumnHeader({
  columns,
}: {
  columns: DataQueryTableColumns;
}) {
  return (
    <HStack
      justifyContent="space-between"
      gap={3}
      alignItems="center"
      px={1.5}
      pb={1.5}
      mb={0.5}
      borderBottomWidth="1px"
      borderColor="border.subtle"
    >
      <HStack gap={1.5} alignItems="center" flex={1} minWidth={0}>
        {columns.leading ? (
          <MetaDefault color="fg.muted" flexShrink={0}>
            {columns.leading}
          </MetaDefault>
        ) : null}
        <MetaDefault color="fg.muted" truncate>
          {columns.primary}
        </MetaDefault>
      </HStack>
      {columns.secondary ? (
        <MetaDefault color="fg.muted" flexShrink={0}>
          {columns.secondary}
        </MetaDefault>
      ) : null}
    </HStack>
  );
}
